import {gql} from '@apollo/client';

export const QUERY_TASK_LIST = gql`
  query TaskList($kind: String, $lessonId: ID!) {
    taskList(lesson: $lessonId, kind: $kind) {
      id
      words
      hint
      lesson {
        trialVariants
        finalVariants
      }
    }
  }
`;

export const MUTATION_ANSWER_MASS_CREATE = gql`
  mutation AnswerMassCreate($input: AnswerMassCreateInput!) {
    answerMassCreate(input: $input) {
      obj {
        id
        isRight
        taskId
      }
      errors {
        field
        messages
      }
    }
  }
`;
